// react-redux imports
import { MouseEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";
import { setOccupantCount } from "./residenceSlice";

// common imports
import CircleButtonContainer from "common/components/styled-components/CircleButtonContainer";
import CircleButton from "common/components/CircleButton";
import SectionTitle from "common/components/styled-components/SectionTitle";

// local imports
import StepOne from "./StepOne";

function StepTwo() {
  const dispatch = useDispatch();
  const occupantCount = useSelector(
    (state: RootState) => state.calculator.residence.occupantCount
  );
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  function handleOccupantCountSelection(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    dispatch(setOccupantCount(Number(e.currentTarget.value)));
  }

  return (
    <>
      {upDesktopScreen && <StepOne buttonSize={133} />}
      <SectionTitle mt>¿Cuántas personas sois?</SectionTitle>
      <CircleButtonContainer>
        <CircleButton
          value={1}
          text="1"
          selected={occupantCount === 1}
          onClick={handleOccupantCountSelection}
        />
        <CircleButton
          value={2}
          text="2"
          selected={occupantCount === 2}
          onClick={handleOccupantCountSelection}
        />
        <CircleButton
          value={3}
          text="3"
          selected={occupantCount === 3}
          onClick={handleOccupantCountSelection}
        />
        <CircleButton
          value={4}
          text="4"
          selected={occupantCount === 4}
          onClick={handleOccupantCountSelection}
        />
        <CircleButton
          value={5}
          text="+5"
          selected={occupantCount === 5}
          onClick={handleOccupantCountSelection}
        />
      </CircleButtonContainer>
    </>
  );
}

export default StepTwo;
